import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ControlsComponent } from './ui/controls/controls.component';
import { LoadingScreenComponent } from './ui/loading-screen/loading-screen.component';
import { TargetComponent } from './ui/target/target.component';
import { HealthBarComponent } from './ui/health-bar/health-bar.component';
import { WordControllerComponent } from './ui/word-controller/word-controller.component';
import { WeaponWheelComponent } from './ui/weapon-wheel/weapon-wheel.component';
import { ProgressBarComponent } from './ui/progress-bar/progress-bar.component';
import { WantedLevelComponent } from './ui/wanted-level/wanted-level.component';
import { WastedOverlayComponent } from './ui/wasted-overlay/wasted-overlay.component';
import { DebugComponent } from './ui/debug/debug.component';
import { WantedLevelService } from "./world/WantedLevelService";
import { RuleOfThirdsComponent } from './ui/rule-of-thirds/rule-of-thirds.component';

@NgModule({
  declarations: [
    AppComponent,
    ControlsComponent,
    LoadingScreenComponent,
    TargetComponent,
    HealthBarComponent,
    WordControllerComponent,
    WeaponWheelComponent,
    ProgressBarComponent,
    WantedLevelComponent,
    WastedOverlayComponent,
    DebugComponent,
    RuleOfThirdsComponent,
  ],
  imports: [
    BrowserModule
  ],
  providers: [WantedLevelService],
  bootstrap: [AppComponent]
})
export class AppModule { }
